export const CITY = '/city/' as const
export const CITY_ALL = `${CITY}all` as const
